<template>
  <b-modal
    style="width:1000px"
    size="xxl"
    @show="onModalShow"
    @hide="onModalHide"
    id="editQuoteModal"
    body-bg-variant="light"
    hide-footer
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->

      <h5 class="pt-1">Angebotsbearbeitung</h5>
      <b-button
        size="sm"
        variant="primary"
        class="text-white px-1"
        style="padding-top:2px;padding-bottom:2px;"
        @click="close()"
      >
        Schließen
      </b-button>
    </template>
    <b-overlay :show="isLoading" style="height:300px">
      <div class="container" v-show="!isLoading">
        <div class="row bg-white border-bottom">
          <div class="col mb-4">
            <div class="row">
              <div class="col-2">
                <label class="text-muted d-block mb-1"><small>VE-Nr</small></label>
                <div class="bg-light p-1">
                  {{ allocationUnit.Ordinal }}
                </div>
              </div>
              <div class="col">
                <label class="text-muted d-block mb-1"><small>Bezeichnung</small></label>
                <div class="bg-light p-1">
                  {{ allocationUnit.DisplayName }}
                </div>
              </div>
              <div class="col-2">
                <label class="text-muted d-block mb-1"><small>Budget</small></label>
                <div class="bg-light p-1 text-right">
                  {{ formatCurrency(allocationUnit.BudgetTotal) }}
                </div>
              </div>
              <div class="col-2">
                <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
                <div class="bg-light p-1 text-right">
                  {{ parseFloat(allocationUnit.NTR) + ' %' }}
                </div>
              </div>
              <div class="col-2">
                <label class="text-muted d-block mb-1"><small>Zielvergabe</small></label>
                <div class="bg-light p-1 text-right">
                  {{
                    formatCurrency(parseFloat(allocationUnit.BudgetSaldo) * (1 - parseFloat(allocationUnit.NTR / 100)))
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-show="!isLoading">
        <div class="row mt-3">
          <div class="col">
            <b-card no-body class="header-condensed" header-bg-variant="primary-semi-light">
              <template #header>
                <span class="float-right">
                  <b-button
                    size="sm"
                    style="padding:2px;padding-top:0;padding-bottom:0;font-size:90%"
                    @click="onButtonAddClick"
                    :disabled="false"
                    class="mr-2"
                    v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                  >
                    Hinzufügen
                  </b-button>
                  <!---
                  <b-button
                    size="sm"
                    style="padding:2px;padding-top:0;padding-bottom:0;font-size:90%"
                    @click="onButtonSelectClick"
                    :disabled="false"
                    variant="outline-secondary"
                  >
                    Aktivieren
                  </b-button>
                  --->
                </span>
                <h6 class="m-0 pr-0" style="padding-top:3px">Angebotsübersicht</h6>
              </template>
              <b-form-radio-group
                id="radio-group-1"
                v-model="selectedQuote"
                @change="switchQuote"
                name="radio-options"
                :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
              >
                <b-table
                  :items="items"
                  :fields="fields"
                  selectable
                  select-mode="single"
                  hover
                  head-variant="white"
                  borderless
                  striped
                  class="mb-0"
                  sticky-header="305px"
                  style="height:303px"
                  @row-selected="onRowSelected"
                  show-empty
                  :tbody-tr-class="getTrClass"
                >
                  <template #empty>
                    <div class="text-center text-muted bg-white mt-4">Keine Angebote erfasst.</div>
                  </template>
                  <template #cell(idx)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(actions)="data">
                    <b-icon
                      icon="trash"
                      class="text-muted"
                      style="font-size:115%"
                      @click.stop="deleteQuote(data.item)"
                      v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                    />
                  </template>
                  <template #head(Selected)>
                    <b-form-radio name="some-radios" value="-1">Auswahl</b-form-radio>
                  </template>
                  <template #cell(Selected)="data">
                    <b-form-radio :value="data.item.DbId"></b-form-radio>
                    <!--
                  <span
                    data-v-0a72b170=""
                    class="badge font-weight-normal p-1 m-0 d-inline align-middle badge-primary text-white"
                    v-if="data.item.Selected == 1"
                  >
                    Aktiv
                  </span>
                  -->
                    <!--- <span
                    class="bg-primary text-white rounded-circle align-top"
                    
                    style="display:inline-block;width:20px;height:20px;text-align:center;font-size:120%;"
                  ></span> --->
                  </template>
                </b-table>
              </b-form-radio-group>
            </b-card>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <b-card class="header-condensed" header-bg-variant="primary-semi-light" body-class="pt-3 pb-2">
              <template #header>
                <span class="float-right">
                  <b-button
                    :disabled="!formIsDirty"
                    size="sm"
                    class="mr-2"
                    style="padding:2px;padding-top:0;padding-bottom:0;font-size:90%"
                    @click="onButtonSaveClick"
                    v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                  >
                    Speichern
                  </b-button>
                  <b-button
                    :disabled="!formIsDirty"
                    size="sm"
                    style="padding:2px;padding-top:0;padding-bottom:0;font-size:90%"
                    @click="onButtonDiscardClick"
                    v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                  >
                    Verwerfen
                  </b-button>
                </span>
                <h6 class="m-0" style="padding-top:3px">Angebot erfassen / bearbeiten</h6>
              </template>
              <b-form ref="QuoteForm" id="QuoteForm" @submit.prevent>
                <div class="row">
                  <div class="col-6 pr-0">
                    <b-form-group id="input-group-quote" label="Firma" label-for="input-Firma" label-class="small mb-1">
                      <b-form-input
                        v-model="selectedItem.Company"
                        id="input-Firma"
                        type="text"
                        placeholder="Firma"
                        required
                        @focus="$event.target.select()"
                        @keyup.enter="
                          onOkClick();
                          $bvModal.hide('editQuoteModal');
                        "
                        @keyup="onFormFieldKeyUp"
                        ref="fieldCompany"
                        :readonly="!($root.$user.isPlaner || $root.$user.isAdmin)"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-3  pr-0">
                    <AkCurrencyField
                      label="Angebotspreis"
                      label-class="small mb-1"
                      v-model="selectedItem.Amount"
                      id="input-Quote"
                      type="number"
                      placeholder="Angebot"
                      required
                      @focus="$event.target.select()"
                      @keyup.enter="
                        onOkClick();
                        $bvModal.hide('editQuoteModal');
                      "
                      @keyup="onFormFieldKeyUp"
                      min="0.01"
                      :readonly="!($root.$user.isPlaner || $root.$user.isAdmin)"
                    />
                  </div>

                  <div class="col-3">
                    <b-form-group id="input-group-date" label="Datum" label-for="input-Date" label-class="small mb-1">
                      <b-form-input
                        v-model="selectedItem.QuoteDate"
                        id="input-Date"
                        type="date"
                        placeholder="Datum"
                        required
                        @focus="$event.target.select()"
                        @keyup.enter="
                          onOkClick();
                          $bvModal.hide('editQuoteModal');
                        "
                        @keyup="onFormFieldKeyUp"
                        :readonly="!($root.$user.isPlaner || $root.$user.isAdmin)"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <b-form-group
                      id="input-group-comment"
                      label="Kommentar"
                      label-for="input-comment"
                      label-class="small mb-1"
                    >
                      <b-form-input
                        v-model="selectedItem.Comment"
                        id="input-comment"
                        type="text"
                        placeholder="Kommentar"
                        @focus="$event.target.select()"
                        @keyup.enter="
                          onOkClick();
                          $bvModal.hide('editQuoteModal');
                        "
                        @keyup="onFormFieldKeyUp"
                        :readonly="!($root.$user.isPlaner || $root.$user.isAdmin)"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </b-form>
            </b-card>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import settingsStore from '@/store/Settings';
import allocationUnitsService from '@/service/AllocationUnitsService';
import AkCurrencyField from '@/components/AkCurrencyField';
export default {
  components: {
    AkCurrencyField
  },
  props: ['allocationUnit'],
  data() {
    return {
      settingsStore,
      selectedQuote: 41,
      items: [],
      fields: [
        { key: 'idx', label: '', thClass: 'py-1' },
        { key: 'Company', label: 'Firma', thClass: 'py-1' },
        {
          key: 'Amount',
          label: 'Angebot',
          formatter: x => this.$utils.formatCurrency(x, settingsStore),
          tdClass: 'text-right',
          thClass: 'py-1 text-right',
          sortable: true
        },

        { key: 'QuoteDate', label: 'Datum', thClass: 'py-1', formatter: x => this.$utils.SQLDateToGermanDate(x) },
        { key: 'Comment', label: 'Kommentar', thClass: 'py-1' },
        { key: 'Selected', label: '', thClass: 'py-1', thStyle: 'width:45px' },
        { key: 'actions', label: '' }
      ],
      value: {
        Quote: null
      },
      isLoading: true,
      selectedItem: {
        Amount: null,
        Company: null,
        QuoteDate: null,
        Comment: null,
        DbId: -1,
        VeDbId: this.allocationUnit.DbId
      },
      formIsDirty: false,
      isDirty: false
    };
  },
  emits: ['ok', 'error'],
  methods: {
    loadQuotes() {
      allocationUnitsService
        .getAllocationUnitQuotes(this.allocationUnit.DbId)
        .then(items => {
          this.items = items.map(x => {
            x.QuoteDate = this.$utils.SQLDateToBrowserDate(x.QuoteDate);
            return x;
          });

          const selectedQuote = this.items.find(x => x.Selected == 1);
          if (selectedQuote) this.selectedQuote = selectedQuote.DbId;
          else this.selectedQuote = -1;
          this.formIsDirty = false;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(() => (this.isLoading = false));
    },
    deleteQuote(quote) {
      allocationUnitsService
        .deleteQuote(this.allocationUnit.DbId, quote.DbId)
        .then(() => {
          this.isDirty = true;
          this.loadQuotes();
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    switchQuote(quoteDbId) {
      const selectedQuote = this.items.find(x => x.DbId == quoteDbId);
      allocationUnitsService
        .selectQuote(this.allocationUnit.DbId, selectedQuote ? selectedQuote.DbId : null, selectedQuote !== null)
        .then(updatedAllocationUnit => {
          this.allocationUnit.ActiveQuoteAmount = selectedQuote ? selectedQuote.Amount : 0;
          this.allocationUnit.Status = updatedAllocationUnit.Status;
          this.allocationUnit.StatusText = updatedAllocationUnit.StatusText;
          this.allocationUnit.ProcessStatus = updatedAllocationUnit.ProcessStatus;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
      /*
      const currentSelected = this.items.find(x => x.Selected == 1);
      if (currentSelected) currentSelected.Selected = '';
      const newlySelected = this.items.find(x => x.DbId == item.DbId);
      if (newlySelected && currentSelected && newlySelected.DbId == currentSelected.DbId) {
        newlySelected.Selected = 0;
      } else {
        newlySelected.Selected = 1;
      }
      console.log('zzz newly', newlySelected);
      allocationUnitsService
        .selectQuote(item.VeDbId, item.DbId, newlySelected.Selected)
        .then(updatedAllocationUnit => {
          this.allocationUnit.ActiveQuoteAmount = newlySelected.Amount * newlySelected.Selected;
          this.allocationUnit.Status = updatedAllocationUnit.Status;
          this.allocationUnit.StatusText = updatedAllocationUnit.StatusText;
          this.allocationUnit.ProcessStatus = updatedAllocationUnit.ProcessStatus;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
      this.items.forEach(x => (x.Selected = false));
      item.Selected = true;
      */
    },
    deactivateQuotes() {
      this.items.forEach(x => (x.Selected = false));
      console.log('zzz', this.items);
    },
    onRowSelected(item) {
      if (item.length > 0) this.selectedItem = { ...item[0] };
      this.formIsDirty = false;
    },
    onFormFieldKeyUp(key) {
      if (
        key.which == 9 ||
        key.which == 13 ||
        key.which == 16 ||
        key.which == 27 ||
        key.which == 32 ||
        key.which == 35 ||
        key.which == 36 ||
        key.which == 37 ||
        key.which == 39
      )
        return;

      this.formIsDirty = true;
    },
    onModalShow() {
      this.selectedItem = {
        Amount: null,
        Company: null,
        QuoteDate: null,
        Comment: null,
        DbId: -1,
        VeDbId: this.allocationUnit.DbId
      };
      this.isLoading = true;
      this.isDirty = false;
      if (this.allocationUnit.NTR == null) this.allocationUnit.NTR = 0.0;
      this.value = { ...this.allocationUnit };
      this.loadQuotes();
    },
    onButtonSaveClick() {
      if (!this.$refs.QuoteForm.checkValidity()) {
        return this.$refs.QuoteForm.reportValidity();
      }
      if (this.selectedItem.DbId == -1) {
        allocationUnitsService
          .createNewQuote(this.selectedItem)
          .then(() => {
            this.formIsDirty = false;
            this.isDirty = true;
            this.loadQuotes();
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          });
      } else {
        allocationUnitsService
          .updateQuote(this.selectedItem)
          .then(() => {
            this.formIsDirty = false;
            this.isDirty = true;
            this.selectedItem.wasUpdated = true;
            this.loadQuotes();
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          });
      }
      this.formIsDirty = false;
    },
    onButtonSelectClick() {
      const currentSelected = this.items.find(x => x.Selected == 1);
      if (currentSelected) currentSelected.Selected = '';
      const newlySelected = this.items.find(x => x.DbId == this.selectedItem.DbId);
      if (newlySelected && currentSelected && newlySelected.DbId == currentSelected.DbId) {
        newlySelected.Selected = 0;
      } else {
        newlySelected.Selected = 1;
      }
      allocationUnitsService
        .selectQuote(this.selectedItem.VeDbId, this.selectedItem.DbId, newlySelected.Selected)
        .then(updatedAllocationUnit => {
          this.allocationUnit.ActiveQuoteAmount = newlySelected.Amount * newlySelected.Selected;
          this.allocationUnit.Status = updatedAllocationUnit.Status;
          this.allocationUnit.StatusText = updatedAllocationUnit.StatusText;
          this.allocationUnit.ProcessStatus = updatedAllocationUnit.ProcessStatus;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    onButtonDiscardClick() {
      this.formIsDirty = false;
      if (this.selectedItem.DbId != -1)
        this.selectedItem = { ...this.items.find(x => x.DbId == this.selectedItem.DbId) };
    },
    onButtonAddClick() {
      this.selectedItem = {
        Amount: null,
        Company: null,
        QuoteDate: null,
        Comment: null,
        VeDbId: this.allocationUnit.DbId,
        DbId: -1
      };
      this.formIsDirty = true;
      this.$refs.fieldCompany.focus();
    },
    getTrClass(item) {
      if (!item) return;
      return item.wasUpdated ? 'update-success' : '';
    },
    onModalHide() {
      if (this.isDirty) {
        return this.$emit('ok', this.allocationUnit);
      }
    },
    formatCurrency(number) {
      return this.$utils.formatCurrency(number, this.settingsStore);
    }
  }
};
</script>

<style>
.modal-xxl {
  max-width: 950px !important;
}
.modal-xxl .modal-header {
  border-bottom: none;
}
.modal-xxl .modal-body {
  height: 80vh;
  padding: 0;
}
.header-condensed .card-header {
  padding: 5px 5px 5px 15px !important ;
}
</style>
